import { blue, green, neutral, orange, purpleBrand, red } from './primitives.colors';

/** Semântica ARIDE — tema escuro (valores resolvidos). */
export const semanticDark = {
  brandMain: purpleBrand[400],
  brandSupport: purpleBrand[200],
  primaryMain: purpleBrand[500],
  primaryLight: purpleBrand[400],
  primaryDark: purpleBrand[600],
  primaryContrastText: neutral[0],
  secondaryMain: neutral[600],
  secondaryLight: neutral[800],
  secondaryDark: neutral[600],
  secondaryContrastText: neutral[0],
  tertiaryMain: purpleBrand[500],
  /** Texto sobre superfície `backgroundTertiary` (dark: fundo marca escuro → texto claro). */
  tertiaryContrastText: neutral[0],
  textPrimary: neutral[0],
  textSecondary: neutral[400],
  textDisabled: neutral[800],
  textPlaceholder: neutral[400],
  accent: neutral[900],
  backgroundPrimary: neutral[1100],
  backgroundSecondary: neutral[1000],
  /** Tarjas informativas em UI escura (evita bloco “pastel” do tema claro). */
  backgroundTertiary: purpleBrand[1100],
  backgroundMute: neutral[600],
  backgroundBlack: neutral[0],
  divider: neutral[700],
  elevation: neutral[600],
  successMain: green[500],
  successLight: green[400],
  successDark: green[700],
  successContrastText: neutral[1100],
  errorMain: red[600],
  errorLight: red[300],
  errorDark: red[800],
  errorContrastText: neutral[0],
  warningMain: orange[300],
  warningLight: orange[200],
  warningDark: orange[600],
  warningContrastText: neutral[1100],
  infoMain: blue[300],
  infoLight: blue[200],
  infoDark: blue[500],
  infoContrastText: neutral[1100],
  chart1: purpleBrand[400],
  chart2: blue[400],
  chart3: green[400],
  chart4: orange[400],
  chart5: red[400]
} as const;
